"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnemyKilledEventArgs = void 0;
const EventType_1 = require("../EventType");
class EnemyKilledEventArgs {
    constructor(enemyId) {
        this.enemyId = enemyId;
        this.__type = EventType_1.EventType.EnemyKilled;
        this.__typeName = "EnemyKilled";
    }
}
exports.EnemyKilledEventArgs = EnemyKilledEventArgs;
